import React from 'react';

import { Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { useMLSummaryFeedback } from 'reducers/reviewFormSlice';
import useReviewFormSidebarQueryData from 'screens/performanceReview/hooks/useReviewFormSidebarQueryData';

import { Feedback } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { Tooltip } from 'uiToolkitV1/Tooltip/Tooltip';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

const FeedbackButton = styled(Button)`
  & svg {
    color: #999 !important;
  }
  :hover {
    & svg {
      color: #125aa9 !important;
    }
  }
  ${({ isAnswered }) =>
    isAnswered &&
    ` 
      cursor: default !important;
  & svg {
    color: #125aa9 !important;
  }`}
  padding: 4px;
  margin-right: 4px;
`;

const FeedbackButtonNegative = styled(FeedbackButton)`
  transform: rotate(180deg);
`;

const usePreStoredFeedback = ({ reviewId, revieweeId, questionId, competencyId, goalId }) => {
  const mlFeedback = useMLSummaryFeedback();

  const matchedFeedback = mlFeedback.find(
    (feedback) =>
      feedback.reviewId === reviewId &&
      feedback.revieweeId === revieweeId &&
      feedback.questionId === questionId &&
      feedback.competencyId === competencyId &&
      feedback.goalId === goalId
  );

  if (matchedFeedback) return matchedFeedback.isLike;

  return null;
};

const ManagerSummaryFeedback = ({
  isProvidedFeedback = null,
  onGiveFeedbackHandler,
  reviewId,
  questionId,
  competencyId,
  revieweeId,
  goalId,
}) => {
  const data = useReviewFormSidebarQueryData();

  const { reviewInfo = [] } = data ?? {};

  const preStoredFeedback = usePreStoredFeedback({
    reviewId,
    revieweeId,
    questionId,
    competencyId,
    goalId,
  });
  const hideThumbsDown = isProvidedFeedback === true || preStoredFeedback === true;
  const hideThumbsUp = isProvidedFeedback === false || preStoredFeedback === false;
  const disableButtons = isProvidedFeedback !== null || preStoredFeedback !== null;

  const clickHandler = (isLike) => {
    if (isProvidedFeedback !== null || preStoredFeedback !== null) return;
    onGiveFeedbackHandler({ isLike, responseId: reviewInfo?.id });
  };

  return (
    <Flex flexDir="column" flexGrow={1}>
      <Flex
        // borderRadius="px"
        bg="linear-gradient(90deg, rgba(0, 142, 240, 0.50) 1.83%, rgba(236, 59, 100, 0.50) 34.86%, rgba(255, 194, 0, 0.50) 65.54%, rgba(92, 196, 97, 0.50) 100%)"
        w="100%"
        h="1px"
        mb={1}
        mt={3}
      />
      <Flex alignItems="center">
        <TextBodyMedium color="text.g2" mr={2} px={1}>
          Is this useful?
        </TextBodyMedium>
        {!hideThumbsUp && (
          <Tooltip label="Yes" placement="top">
            <FeedbackButton
              variant="tertiary"
              StartIcon={Feedback}
              isAnswered={disableButtons}
              onClick={() => clickHandler(true)}
            />
          </Tooltip>
        )}
        {!hideThumbsDown && (
          <Tooltip label="No" placement="top">
            <FeedbackButtonNegative
              variant="tertiary"
              StartIcon={Feedback}
              isAnswered={disableButtons}
              onClick={() => clickHandler(false)}
            />
          </Tooltip>
        )}
      </Flex>
    </Flex>
  );
};

export default ManagerSummaryFeedback;
